// extracted by mini-css-extract-plugin
export default {"drinkNotImg":"FavouriteDrinksPage_drinkNotImg__ICmjp","drinkNotImgText":"FavouriteDrinksPage_drinkNotImgText__6f3N5"};